import { RenderRoutes } from './Routes'

// TODO : Add SuspenseSpinner as component when page is loadingf
// import SuspenseSpinner from 'components/SuspenseFallback'

// eslint-disable-next-line react/react-in-jsx-scope

export default RenderRoutes
